import { TAG_SORT } from "../constants/tagConstants";

class Tag {
  constructor(data = {}) {
    const { candidates, normalized, count, year } = data;
    this.candidates = candidates || [];
    this.tagType = data.tagType;
    this.position = data.position;
    this.score = data.score;
    this.start = data.start;
    this.end = data.end;
    this.sortVal = TAG_SORT[this.tagType] || 100;

    this.normalized = normalized || "";
    this.text = data.text;
    this.count = count;
    this.totalCount = count;
    this.year = year;
    this.key = `${this.year || "-"}:${this.tagType}:${this.normalized}`;
    this.typeKey = `${this.tagType}:${this.normalized}`;
    this.variantIds = data.variantIds?.length ? data.variantIds : [];
    this.geneId = data.geneId;
  }

  clone() {
    return new Tag(this);
  }

  setYear(year) {
    this.year = year;
    this.key = `${this.year}:${this.tagType}:${this.normalized}`;
    return this;
  }

  get url() {
    const { normalized: norm, tagType: type } = this;
    const isVar = type === "variant";
    const isGene = type === "gene";
    const { varsome_host: varsomeHost } = window.varsomeConfig;
    const { pathname, search, hash } = window.location;
    const isHg38 = pathname.indexOf("/hg38") > -1;
    const hg38Var = this.variantIds.find((x) => x.startsWith("1038")) || [];
    const hg19Var = this.variantIds.find((x) => x.startsWith("1019")) || [];
    const host = varsomeHost || window.location.origin; // varsome host might not exist eg in citations page.

    if (isGene) return `${host}/search-results/${norm}${search}${hash}`;
    if (isVar && isHg38)
      return `${host}/variant/hg38/${hg38Var}${search}${hash}`;
    if (isVar && !isHg38)
      return `${host}/variant/hg19/${hg19Var}${search}${hash}`;

    return null;
  }
}

export default Tag;
